module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n<div ko.globalevent.beforeunload=\"onBeforeUnload\"></div>\n";
